import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './locales-i18next';

export const initI18n = () => {
    i18n.use(LanguageDetector)
        .use(initReactI18next)
        .init({
            fallbackLng: 'en',
            supportedLngs: ['nl', 'en'],
            resources: {
                nl: {translation: resources.nl},
                en: {translation: resources.en},
            },
            detection: {
                order: ['navigator'],
                caches: [],
            },
        });
};
